import React from 'react';
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/lib/Async'
import CustomOption from '../AddOnDropdown/CustomOption'
import QuantityToken from '../AddOnDropdown/QuantityToken'
import BasicToken from '../AddOnDropdown/BasicToken'
// https://react-select.com/async#loading-asynchronously
import client from '../../helpers/client'
import '../AddOnDropdown/index.scss'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    fontSize: 18,
    paddingLeft: 10
  })
}

const deserializeExtra = (extra) => {
  if(extra && extra.id && extra.attributes) {
    return {
      quantity: extra.quantity ? extra.quantity : 1,
      value: extra.id,
      label: extra.attributes.name,
      attributes: extra.attributes
    }
  }
  else {
    return null
  }
}

const deserializeExtras = (serializedExtras) => {
  // If serializedExtras is an array
  if(Array.isArray(serializedExtras)) {
    return serializedExtras.map(extra => deserializeExtra(extra)).filter(extra => extra)
  }
  else {
    return deserializeExtra(serializedExtras)
  }
}



class ExtraDropdown extends React.Component {
  static propTypes = {
    extras: PropTypes.array,
    inputId: PropTypes.string,
    selected: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ]),
    apiKey: PropTypes.string.isRequired,
    extraCategoryId: PropTypes.number,
    multiple: PropTypes.bool,
    showQuantities: PropTypes.bool
  }

  static defaultProps = {
    extras: [],
    multiple: false,
    showQuantities: false
  }

  state = {
    selectedOptions: this.props.multiple ? deserializeExtras(this.props.selected) : deserializeExtra(this.props.selected),
    currentValue: ""
  }

  componentDidMount() {
    const { inputId } = this.props

    if(inputId) {
      this.input = document.getElementById(inputId)
      this.syncHtmlInput()
    }
  }

  handleInputChange = (currentValue) => {
    this.setState({ currentValue })
  }

  handleChange = (selectedOptions) => {
    this.setState({ selectedOptions }, () => this.syncHtmlInput())

  }

  syncHtmlInput() {
    const { showQuantities } = this.props
    const { selectedOptions } = this.state

    if(this.input) {
      if(selectedOptions) {
        if(Array.isArray(selectedOptions) && showQuantities) {
          this.input.value = selectedOptions.map(option => `${option.quantity}x${option.value}`).join(",")
        }
        else if(Array.isArray(selectedOptions)) {
          this.input.value = selectedOptions.map(option => option.value).join(",")
        }
        else {
          this.input.value = selectedOptions.value
        }
      }
      else {
        this.input.value = ""
      }
    }
  }

  handleLoadOptions = (inputValue, callback) => {
    const { apiKey, extraCategoryId } = this.props
    const { currentValue } = this.state

    let params = {
      api_key: apiKey,
      text: currentValue,
      order: "name",
      only_widget_visible: 0
    }
    if (extraCategoryId) {
      params.extra_category_id = extraCategoryId
    }
    const url = `/api/v1/extras.json?${new URLSearchParams(params).toString()}`

    client.get(url)
      .then(response => {
        const options = deserializeExtras(response.data.data)
        callback(options)
      })
      .catch(error => {
        const { data, status } = error.response
        const { errors } = data
        const errorMessage = status === 422 ? errors.join(", ") : "Error contacting server"
        alert(errorMessage)
      })
  }



  render() {
    const { extras, extraCategoryNamePluralized, multiple, showQuantities } = this.props
    const { selectedOptions, currentValue } = this.state;

    const placeholderText = extraCategoryNamePluralized ? extraCategoryNamePluralized.toLowerCase() : "extras";

    return (
      <AsyncSelect
        cacheOptions
        name={"extra_id"}
        loadOptions={this.handleLoadOptions}
        onInputChange={this.handleInputChange}
        onChange={this.handleChange}
        components={{
          Option: CustomOption,
          MultiValueLabel: showQuantities ? QuantityToken : BasicToken,
        }}
        styles={customStyles}
        placeholder="Start typing..."
        noOptionsMessage={() => currentValue ? `Unable to find any matching ${placeholderText}` : `Start typing to search for ${placeholderText}`}
        defaultOptions={deserializeExtras(extras)}
        value={selectedOptions}
        isClearable={true}
        isMulti={multiple}
      />
    );
  }
}

export default ExtraDropdown
